// `cn` is the shadcn-ecosystem package (compiled clsx + tailwind-merge
// tables) the v4 registry components import directly; re-export it here so
// app code keeps its `@/lib/utils` import and both share one merge engine.
export { cn } from "cn";

/** Tab/label count suffix — blank while undefined so labels don't jump when
 * counts arrive. */
export const countSuffix = (n?: number) => (n === undefined ? "" : ` (${n})`);
